export default {
  TITLE_CONT: 'titleCont'
}
